export const GET_USERS_URL = 'https://jsonplaceholder.typicode.com/users';
